<template>
    <el-dialog class="preview-dialog" title="预览" :visible.sync="dialogVisible" size="large">
        <div v-if="baseData" style="overflow:auto">
            <div style="border-bottom: 1px solid #ddd;">
                <p style="font-size: 16px;font-weight: bold;">邮件标题：{{baseData.name}}</p>
                <p>发送时间：{{baseData.sendTime}}</p>
            </div>
            <div style="border-top: 1px solid #ddd;">
                <div v-html="baseData.content"></div>
            </div>
        </div>
    </el-dialog>
</template>

<style lang="scss">
    .preview-inlineForm{
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            width: 300px;
            margin: 4px 0;
        }
        .el-form-item__content{
            width: 180px;
        }
    }
    .preview-dialog{
        pre{
            margin: 0;
            white-space: pre-line;
        }
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            margin: 4px 0;
        }
    }
</style>

<script>
    import selectMapMixin from 'mixins/selectMapMixin'
    import { Loading } from 'element-ui'

    export default {
        mixins: [selectMapMixin],
        data () {
            return {
                styleStr: `
                    <style>
                        html{overflow: auto}
                        /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
                        ::-webkit-scrollbar{
                            width: 10px;
                            height: 10px;
                            background-color: #eee;
                        }
                        /*定义滚动条的轨道，内阴影及圆角*/
                        ::-webkit-scrollbar-track{
                            background-color: #eee;
                        }
                        /*定义滑块，内阴影及圆角*/
                        ::-webkit-scrollbar-thumb{
                            /*width: 10px;*/
                            height: 10px;
                            background-color: #ddd;
                        }</style>
                    `,
                configMap: this.$store.state.baseData.selectMap,
                formLabelWidth: '110px',
                baseData: null,
                dialogVisible: false
            }
        },
        methods: {
            show (data) {
                this.baseData = data
                this.dialogVisible = true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// viewEmailHistoryItem.vue?16905e5c